<div class="dialog-wrapper inspection-type-description-dialog" cdkTrapFocus cdkTrapFocusAutoCapture>
  <div mat-dialog-title>
    <div class="dialog-title"> {{ 'DESCRIPTIONS' | translate }} </div>
  </div>
  <mat-dialog-content>
    <div class="dialog-content" tabindex="0">
      <ul>
        <li *ngFor="let item of inspectionTypeDescriptions" >
          <span>{{ item.name | translate }}: </span>{{ item.description | translate }}
        </li>
      </ul>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button
      class="special-button"
      #okButton
      mat-dialog-close
      >{{ 'OK' | translate }}</button>
  </mat-dialog-actions>
</div>
